import { useTranslations } from "../../../i18n/hooks/useTranslations"

/**
 * Privacy policy footer component.
 * Shows links to privacy policy and terms of service.
 */
export const PrivacyPolicyFooter = () => {
  const t = useTranslations("newsletters")

  return (
    <div
      className="mx-auto mt-2 max-w-2xl text-center text-sm text-gray-600"
      dangerouslySetInnerHTML={{ __html: t("privacy_policy_html") }}
    ></div>
  )
}
